import { render, staticRenderFns } from "./b-popup-choose-gong-yi.vue?vue&type=template&id=5ba63a42&scoped=true"
import script from "./b-popup-choose-gong-yi.vue?vue&type=script&lang=js"
export * from "./b-popup-choose-gong-yi.vue?vue&type=script&lang=js"
import style0 from "./b-popup-choose-gong-yi.vue?vue&type=style&index=0&id=5ba63a42&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba63a42",
  null
  
)

export default component.exports